import React, { Fragment, useState, useRef } from "react";
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Label,
  FormGroup,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import _ from "lodash";
import Notifications from "../commons/Notifications";
import FieldWrapper from "../commons/FieldWrapper";
import { savePostulation } from "./Axios";

const PostulationForm = (props) => {
  const notificationsRef = useRef();
  const { publicationQuestions, publicationId, user, role, currentUserRole } = props;
  const [isAlreadyPostulated, setIsAlreadyPostulated] = useState(
    props.isAlreadyPostulated
  );
  const [postulationAnswers, setPostulationAnswers] = useState(() =>
    _.map(publicationQuestions, (question) => {
      const existingAnswer = props.postulationAnswers?.find(
        (answer) => answer.questionId === question.id
      );
      return (
        existingAnswer || {
          questionId: question.id,
          value: question.answer_type === "multiple_choice" ? [] : "",
          errors: [],
        }
      );
    })
  );

  const validatePersonalInformation = () => {
    const personalInfo = user?.personal_information;
    if (!personalInfo) return false;
    const requiredFields = ["first_name", "last_name"];
    const hasRequiredInfo = requiredFields.every(
      (field) => personalInfo[field] && personalInfo[field].trim() !== ""
    );

    const hasCv = user?.cv_url;
    return hasRequiredInfo && hasCv;
  };

  const safeQuestions = publicationQuestions.map((q) => {
    if (q.answer_type === "single_choice" || q.answer_type === "multiple_choice") {
      let opts = q.options;
      if (typeof opts === "string") {
        try {
          opts = JSON.parse(opts);
          if (!Array.isArray(opts)) {
            opts = opts.split(",").map(s => s.trim());
          }
        } catch {
          opts = opts.split(",").map(s => s.trim());
        }
      }
      if (!opts) opts = [];
      return { ...q, options: Array.isArray(opts) ? opts : [] };
    }
    return q;
  });

  console.log("safeQuestions", safeQuestions);

  const handleChangeAnswer = (e, idx, question) => {
    const newPostulationAnswers = [...postulationAnswers];

    if (question.answer_type === "multiple_choice") {
      let val = newPostulationAnswers[idx].value || [];
      if (!Array.isArray(val)) val = [];
      const selectedValue = e.target.value;
      if (e.target.checked) {
        val = [...val, selectedValue];
      } else {
        val = val.filter((v) => v !== selectedValue);
      }
      newPostulationAnswers[idx]["value"] = val;
    }
    else if (question.answer_type === "single_choice") {
      newPostulationAnswers[idx]["value"] = e.target.value;
    }
    else {
      newPostulationAnswers[idx]["value"] = e.target.value;
    }
    newPostulationAnswers[idx]["errors"] = [];
    setPostulationAnswers(newPostulationAnswers);
  };
  const serializeData = () => {
    var formData = new FormData();
    formData.append(`minisite_postulation[id]`, "");
    if (safeQuestions.length > 0) {
      _.map(safeQuestions, (question, key) => {
        let answerValue = postulationAnswers[key].value;
        if (question.answer_type === "multiple_choice" && Array.isArray(answerValue)) {
          answerValue = JSON.stringify(answerValue);
        }
        formData.append(
          `minisite_postulation[postulation_answers_attributes][${key}][answer]`,
          answerValue
        );
        formData.append(
          `minisite_postulation[postulation_answers_attributes][${key}][publication_question_id]`,
          postulationAnswers[key].questionId
        );
      });
    }

    return formData;
  };

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validatePersonalInformation()) {
      toggle();
      return;
    }
    const data = serializeData();
    savePostulation(data, publicationId, (response) => {
      if (response.status === 201) {
        notificationsRef.current.addNotifications(
          "Excelente!",
          "Tu postulación ha sido guardada con éxito!",
          "success"
        );
        setIsAlreadyPostulated(true);
      } else if (response.status === 422 && response.data.applicant) {
        notificationsRef.current.addNotifications(
          "Ops",
          response.data.applicant[0],
          "danger"
        );
      } else if (response.status === 422 && response.data.enrollment) {
        notificationsRef.current.addNotifications(
          "Ops",
          response.data.enrollment[0],
          "danger"
        );
      } else if (response.status === 422) {
        notificationsRef.current.addNotifications(
          "Ops",
          "Debe responder a todas las preguntas!",
          "danger"
        );
        const newPostulationAnswers = [...postulationAnswers];
        _.map(newPostulationAnswers, (answer, idx) => {
          if (safeQuestions[idx]?.answer_type === "multiple_choice") {
            if (!Array.isArray(answer.value) || answer.value.length === 0)
              answer["errors"].push("Debe seleccionar al menos una opción");
          } else {
            if (answer.value === "" || answer.value == null)
              answer["errors"].push("Debe ingresar una respuesta");
          }
        });
        setPostulationAnswers(newPostulationAnswers);
      }
    });
  };

  return (
    <Fragment>
      <Notifications ref={notificationsRef} />
      {safeQuestions.length > 0 && (
        <Row>
          <Col md="12">
            <h3 className="h6 font-weight-bold">
              <i className="fas fa-question mr-2"></i>
              Preguntas de la Publicación
            </h3>
            <ListGroup flush>
              {_.map(safeQuestions, (question, key) => {
                const questionText = question.value || question.name || "";
                return (
                <ListGroupItem key={key}>
                  <FormGroup>
                    <Label
                      for={`question${key + 1}`}
                      className="input_required"
                    >
                      {key + 1}.- {questionText}
                    </Label>
                    <FieldWrapper errors={postulationAnswers[key]?.errors || []}>
                      {(() => {
                        switch (question.answer_type) {
                          case "boolean":
                            return (
                              <div>
                                <FormGroup check inline>
                                  <Label check>
                                    <Input
                                      type="radio"
                                      name={`question${key}`}
                                      value="true"
                                      checked={postulationAnswers[key].value === "true"}
                                      onChange={(e) => handleChangeAnswer(e, key, question)}
                                      disabled={isAlreadyPostulated}
                                    />{" "}
                                    Sí
                                  </Label>
                                </FormGroup>
                                <FormGroup check inline>
                                  <Label check>
                                    <Input
                                      type="radio"
                                      name={`question${key}`}
                                      value="false"
                                      checked={postulationAnswers[key].value === "false"}
                                      onChange={(e) => handleChangeAnswer(e, key, question)}
                                      disabled={isAlreadyPostulated}
                                    />{" "}
                                    No
                                  </Label>
                                </FormGroup>
                              </div>
                            );
                          case "number":
                            return (
                              <Input
                                type="number"
                                placeholder="Ingrese un número"
                                id={`question${key + 1}`}
                                value={postulationAnswers[key].value}
                                onChange={(e) => handleChangeAnswer(e, key, question)}
                                disabled={isAlreadyPostulated}
                              />
                            );
                          case "single_choice":
                            return (
                              <div>
                                {question.options.length > 0 ? (
                                  question.options.map((opt, idx) => (
                                    <FormGroup check key={idx} inline>
                                      <Label check>
                                        <Input
                                          type="radio"
                                          name={`question${key}`}
                                          value={opt}
                                          checked={postulationAnswers[key].value === opt}
                                          onChange={(e) => handleChangeAnswer(e, key, question)}
                                          disabled={isAlreadyPostulated}
                                        />
                                        {opt}
                                      </Label>
                                    </FormGroup>
                                  ))
                                ) : (
                                  <span className="text-danger">Sin opciones configuradas</span>
                                )}
                              </div>
                            );
                          case "multiple_choice":
                            return (
                              <div>
                                {question.options.length > 0 ? (
                                  question.options.map((opt, idx) => (
                                    <FormGroup check key={idx} inline>
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          name={`question${key}`}
                                          value={opt}
                                          checked={postulationAnswers[key].value?.includes(opt)}
                                          onChange={(e) => handleChangeAnswer(e, key, question)}
                                          disabled={isAlreadyPostulated}
                                        />
                                        {opt}
                                      </Label>
                                    </FormGroup>
                                  ))
                                ) : (
                                  <span className="text-danger">Sin opciones configuradas</span>
                                )}
                              </div>
                            );
                          case "text":
                          default:
                            return (
                              <Input
                                type="textarea"
                                placeholder="Escriba su Respuesta"
                                id={`question${key + 1}`}
                                value={postulationAnswers[key].value}
                                onChange={(e) => handleChangeAnswer(e, key, question)}
                                disabled={isAlreadyPostulated}
                              />
                            );
                        }
                      })()}
                    </FieldWrapper>
                  </FormGroup>
                </ListGroupItem>
                );
              })}
            </ListGroup>
          </Col>
        </Row>
      )}
      <Row>
        <Col md="12" className="text-center">
          {isAlreadyPostulated ? (
            <p className="alert alert-primary p-2">Gracias por postular!</p>
          ) : (
            role === "user" &&
            !(Array.isArray(currentUserRole) ? currentUserRole.includes("job_head") : currentUserRole === "job_head") && (
              <Button
                type="button"
                color="primary"
                className="my-3"
                onClick={handleSubmit}
              >
                Postular
              </Button>
            )
          )}
        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          Solicitud de actualización de datos
        </ModalHeader>
        <ModalBody>
          {user?.personal_information ? (
            <p>
              Para continuar se solicita:
              {!validatePersonalInformation() && (
                <ul>
                  {!user?.cv_url && <li>Cargar su Curriculum Vitae (CV)</li>}
                  {(!user?.personal_information?.first_name || !user?.personal_information?.last_name) && (
                    <li>Completar sus datos personales</li>
                  )}
                </ul>
              )}
            </p>
          ) : (
            <FieldWrapper errors={["Debe completar la información personal y cargar su CV"]}>
              <Select />
            </FieldWrapper>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="text-light"
            color="success"
            onClick={() => {
              window.location.href = "/user/new";
            }}
          >
            Actualizar Informacion Personal
          </Button>
          <Button color="danger" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default PostulationForm;